"use client";
import React, {useState} from "react";

export default function PricingSwitcher({data}) {
    const {
        title,
        subtitle,
        toggle = {enabled: true, labels: ["Monthly", "Yearly"]},
        plans = [],
        background = {},
        padding = "xl"
    } = data || {};

    const [billingCycle, setBillingCycle] = useState("monthly");

    const bgStyle =
        background.type === "gradient"
            ? {backgroundImage: background.value}
            : background.type === "color"
                ? {backgroundColor: background.value}
                : background.type === "image"
                    ? {
                        backgroundImage: `url(${background.value})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center"
                    }
                    : {};

    const paddingMap = {
        sm: "py-10 px-4",
        md: "py-16 px-6",
        lg: "py-20 px-6",
        xl: "py-28 px-8"
    };

    return (
        <section className={`${paddingMap[padding] || "py-20 px-6"}`} style={bgStyle}>
            <div className="max-w-7xl mx-auto text-center">
                {title && <h2 className="text-4xl font-bold mb-4">{title}</h2>}
                {subtitle && <p className="text-lg text-gray-600 mb-6">{subtitle}</p>}

                {toggle.enabled && (
                    <div className="mb-10 flex justify-center items-center gap-4">
                        <label className="flex items-center gap-2 cursor-pointer">
                            <span>{toggle.labels?.[0] || "Monthly"}</span>
                            <div className="relative inline-flex items-center">
                                <input
                                    type="checkbox"
                                    checked={billingCycle === "yearly"}
                                    onChange={() =>
                                        setBillingCycle((prev) =>
                                            prev === "monthly" ? "yearly" : "monthly"
                                        )
                                    }
                                    className="sr-only"
                                />
                                <div className="w-12 h-6 bg-gray-300 rounded-full shadow-inner"/>
                                <div
                                    className={`absolute top-0.5 left-0.5 w-5 h-5 bg-white rounded-full shadow transform transition-transform ${
                                        billingCycle === "yearly" ? "translate-x-6" : ""
                                    }`}
                                />
                            </div>
                            <span>{toggle.labels?.[1] || "Yearly"}</span>
                        </label>
                    </div>
                )}

                <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3">
                    {plans.map((plan, idx) => (
                        <div
                            key={idx}
                            className={`border rounded-lg p-6 shadow-sm ${
                                plan.highlighted
                                    ? "border-blue-600 bg-blue-50"
                                    : "border-gray-200 bg-white"
                            }`}
                        >
                            <h3 className="text-xl font-semibold mb-1">{plan.name}</h3>
                            <p className="text-gray-500 mb-4">{plan.description}</p>
                            <div className="text-3xl font-bold mb-4">
                                {plan.currency || "$"}
                                {plan.price?.[billingCycle] ?? 0}
                                <span className="text-sm text-gray-500">
                  {" "}
                                    /{billingCycle === "yearly" ? "yr" : "mo"}
                </span>
                            </div>
                            <ul className="mb-6 text-left text-sm space-y-2 text-gray-700">
                                {plan.features.map((feature, i) => (
                                    <li key={i}>• {feature}</li>
                                ))}
                            </ul>
                            {plan.button && (
                                <a
                                    href={plan.button.href}
                                    className={`inline-block px-5 py-2 text-sm font-medium rounded-md transition ${
                                        plan.button.style === "secondary"
                                            ? "bg-white text-blue-600 border border-blue-600 hover:bg-blue-50"
                                            : "bg-blue-600 text-white hover:bg-blue-700"
                                    }`}
                                >
                                    {plan.button.text}
                                </a>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}